import { useState, useEffect, useCallback } from 'react'
import { fetchAuthSession } from 'aws-amplify/auth'
import axios from 'axios'

const API = import.meta.env.VITE_API_GATEWAY_URL

async function authHeaders() {
    const session = await fetchAuthSession()
    return { Authorization: `Bearer ${session.tokens.idToken.toString()}` }
}

const ROLES = ['SuperAdmins', 'Admins', 'Users']

const MODULO_INFO = {
    conciliacion_bancaria:  { nombre: 'ConciliaciÃ³n Bancaria',   icono: 'ðŸ¦' },
    comparador_dian:        { nombre: 'Comparador DIAN',         icono: 'ðŸ“Š' },
    calendario_tributario:  { nombre: 'Calendario Tributario',   icono: 'ðŸ—“ï¸' },
    asistente_ia:           { nombre: 'Asistente IA Tributario', icono: 'ðŸ¤–' },
    tablero_financiero:     { nombre: 'Tablero Financiero Ejecutivo', icono: 'ðŸ“ˆ' },
    comisiones:             { nombre: 'Gestor de Comisiones',    icono: 'ðŸ’°' },
    mundo_digital:          { nombre: 'Mundo Digital',            icono: '◈' },
    cuenta_compensacion:    { nombre: 'Cuenta de Compensación',  icono: 'ðŸŒ' },
}

// â”€â”€ Modal de Crear/Editar Usuario â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
function UserFormModal({ user, onClose, onSave }) {
    const isEdit = !!user
    const [form, setForm] = useState({
        email:    user?.email    || '',
        name:     user?.name     || '',
        password: '',
    })
    const [saving, setSaving] = useState(false)
    const [error,  setError]  = useState(null)

    const handleSubmit = async (e) => {
        e.preventDefault()
        setSaving(true)
        setError(null)
        try {
            const headers = await authHeaders()
            if (isEdit) {
                await axios.put(
                    `${API}/admin/usuarios/${encodeURIComponent(user.username)}/atributos`,
                    { name: form.name },
                    { headers }
                )
            } else {
                await axios.post(`${API}/admin/usuarios`, {
                    email:    form.email.trim(),
                    name:     form.name.trim(),
                    password: form.password,
                }, { headers })
            }
            onSave()
        } catch (err) {
            setError(err.response?.data?.error || err.message)
        } finally {
            setSaving(false)
        }
    }

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-card" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>{isEdit ? 'âœï¸ Editar Usuario' : 'âž• Crear Usuario'}</h3>
                    <button className="modal-close" onClick={onClose}>âœ•</button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Email</label>
                        <input
                            type="email"
                            value={form.email}
                            disabled={isEdit}
                            onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
                            placeholder="usuario@empresa.com"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Nombre completo</label>
                        <input
                            type="text"
                            value={form.name}
                            onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
                            placeholder="Nombre Apellido"
                        />
                    </div>
                    {!isEdit && (
                        <div className="form-group">
                            <label>ContraseÃ±a temporal</label>
                            <input
                                type="text"
                                value={form.password}
                                onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
                                placeholder="MÃ­n. 8 chars, mayÃºs, nÃºmero, sÃ­mbolo"
                                required
                            />
                            <span className="form-hint">El usuario deberÃ¡ cambiarla en el primer ingreso.</span>
                        </div>
                    )}
                    {error && <div className="admin-alert admin-alert--error">{error}</div>}
                    <div className="form-actions" style={{ marginTop: '1rem' }}>
                        <button type="button" className="btn-ghost" onClick={onClose}>Cancelar</button>
                        <button type="submit" className="btn-primary" disabled={saving}>
                            {saving ? 'Guardando...' : (isEdit ? 'ðŸ’¾ Actualizar' : 'âœ… Crear usuario')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

// â”€â”€ Componente principal â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
function UsuariosManager() {
    const [usuarios,   setUsuarios]   = useState([])
    const [empresas,   setEmpresas]   = useState([])
    const [catalogo,   setCatalogo]   = useState([])
    const [loading,    setLoading]    = useState(true)
    const [editUser,   setEditUser]   = useState(null)     // usuario configurando permisos
    const [formModal,  setFormModal]  = useState(null)     // null | 'create' | user (editar)
    const [form,       setForm]       = useState({ empresa: '', rol: 'Users', modulosHabilitados: [] })
    const [modEmpresa, setModEmpresa] = useState([])
    const [modLoading, setModLoading] = useState(false)
    const [saving,     setSaving]     = useState(false)
    const [toggling,   setToggling]   = useState(null)    // username del que se estÃ¡ activando/desactivando
    const [msg,        setMsg]        = useState(null)
    const [search,     setSearch]     = useState('')

    // â”€â”€ Carga inicial â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const loadData = useCallback(async () => {
        setLoading(true)
        try {
            const headers = await authHeaders()
            const [usersRes, empresasRes, modRes] = await Promise.all([
                axios.get(`${API}/admin/usuarios`,   { headers }),
                axios.get(`${API}/admin/empresas`,   { headers }),
                axios.get(`${API}/admin/modulos`,    { headers }),
            ])
            setUsuarios(usersRes.data.usuarios   || [])
            setEmpresas(empresasRes.data.empresas || [])
            setCatalogo(modRes.data.modulos       || [])
        } catch (err) {
            setMsg({ type: 'error', text: 'Error cargando datos: ' + err.message })
        } finally {
            setLoading(false)
        }
    }, [])

    useEffect(() => { loadData() }, [loadData])

    // â”€â”€ MÃ³dulos de la empresa â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const loadModulosEmpresa = useCallback(async (empresaId) => {
        if (!empresaId) { setModEmpresa([]); return }
        setModLoading(true)
        try {
            const headers = await authHeaders()
            const res = await axios.get(`${API}/admin/empresas/${empresaId}/modulos`, { headers })
            const activos = (res.data.modulos || []).filter(m => m.activo)
            setModEmpresa(activos.map(m => m.id))
        } catch {
            setModEmpresa([])
        } finally {
            setModLoading(false)
        }
    }, [])

    // â”€â”€ MÃ³dulos guardados del usuario â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const loadUserModulos = useCallback(async (username) => {
        try {
            const headers = await authHeaders()
            const res = await axios.get(
                `${API}/admin/usuarios/${encodeURIComponent(username)}/modulos`,
                { headers }
            )
            const guardados = res.data.modulosHabilitados || []
            setForm(f => ({ ...f, modulosHabilitados: guardados }))
        } catch {
            // sin config previa
        }
    }, [])

    // â”€â”€ Abrir panel de permisos â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const handleConfigPermisos = async (user) => {
        setEditUser(user)
        const empresaId = user.empresa || ''
        setForm({ empresa: empresaId, rol: user.rol || 'Users', modulosHabilitados: [] })
        setModEmpresa([])
        if (empresaId) await loadModulosEmpresa(empresaId)
        await loadUserModulos(user.username)
    }

    // â”€â”€ Cambio de empresa en el select â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const handleEmpresaChange = async (e) => {
        const empId = e.target.value
        setForm(f => ({ ...f, empresa: empId, modulosHabilitados: [] }))
        await loadModulosEmpresa(empId)
    }

    const toggleModulo = (modId) => {
        setForm(f => ({
            ...f,
            modulosHabilitados: f.modulosHabilitados.includes(modId)
                ? f.modulosHabilitados.filter(m => m !== modId)
                : [...f.modulosHabilitados, modId]
        }))
    }

    // â”€â”€ Guardar permisos â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const handleSavePermisos = async (e) => {
        e.preventDefault()
        if (!editUser) return
        setSaving(true)
        setMsg(null)
        try {
            const headers = await authHeaders()
            await axios.put(
                `${API}/admin/usuarios/${encodeURIComponent(editUser.username)}/empresa`,
                {
                    empresa:            form.empresa,
                    rol:                form.rol,
                    modulosHabilitados: form.modulosHabilitados,  // selecciÃ³n del usuario
                },
                { headers }
            )
            setMsg({ type: 'success', text: `âœ… ${editUser.email} actualizado correctamente` })
            setEditUser(null)
            await loadData()
        } catch (err) {
            setMsg({ type: 'error', text: err.response?.data?.error || err.message })
        } finally {
            setSaving(false)
        }
    }

    // â”€â”€ Activar / Desactivar usuario â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const handleToggleEnabled = async (user) => {
        setToggling(user.username)
        try {
            const headers = await authHeaders()
            await axios.put(
                `${API}/admin/usuarios/${encodeURIComponent(user.username)}/estado`,
                { enabled: !user.enabled },
                { headers }
            )
            await loadData()
        } catch (err) {
            setMsg({ type: 'error', text: err.response?.data?.error || err.message })
        } finally {
            setToggling(null)
        }
    }

    // MÃ³dulos de la empresa disponibles para asignar al usuario
    const modulosDeEmpresa = catalogo.filter(m => modEmpresa.includes(m.id))

    const filtered = usuarios.filter(u =>
        u.email.toLowerCase().includes(search.toLowerCase()) ||
        u.name?.toLowerCase().includes(search.toLowerCase()) ||
        u.empresa?.toLowerCase().includes(search.toLowerCase())
    )

    return (
        <div className="admin-section">
            {/* Header */}
            <div className="admin-section-header">
                <div>
                    <h2>ðŸ‘¥ Usuarios</h2>
                    <p>Crea usuarios, asigna empresa, rol y mÃ³dulos</p>
                </div>
                <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                    <input
                        className="admin-search"
                        type="text"
                        placeholder="ðŸ” Buscar usuario..."
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                    />
                    <button className="btn-primary btn-sm" onClick={() => setFormModal('create')}>
                        âž• Nuevo usuario
                    </button>
                </div>
            </div>

            {msg && (
                <div className={`admin-alert admin-alert--${msg.type}`}>
                    {msg.text} <button onClick={() => setMsg(null)}>âœ•</button>
                </div>
            )}

            {/* â”€â”€ Modal Crear/Editar â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
            {formModal && (
                <UserFormModal
                    user={formModal === 'create' ? null : formModal}
                    onClose={() => setFormModal(null)}
                    onSave={() => { setFormModal(null); loadData(); setMsg({ type: 'success', text: 'âœ… Usuario guardado' }) }}
                />
            )}

            {/* â”€â”€ Panel Permisos â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
            {editUser && (
                <div className="admin-form-card">
                    <h3>âš™ï¸ Permisos: <span className="highlight">{editUser.email}</span></h3>
                    <form onSubmit={handleSavePermisos}>
                        <div className="form-row">
                            <div className="form-group">
                                <label>ðŸ¢ Empresa</label>
                                <select value={form.empresa} onChange={handleEmpresaChange}>
                                    <option value="">â€” Sin empresa â€”</option>
                                    {empresas.filter(e => e.activa).map(emp => (
                                        <option key={emp.id} value={emp.id}>
                                            {emp.nombre} ({emp.id})
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>ðŸŽ­ Rol del sistema</label>
                                <select value={form.rol} onChange={e => setForm(f => ({ ...f, rol: e.target.value }))}>
                                    {ROLES.map(r => <option key={r} value={r}>{r}</option>)}
                                </select>
                            </div>
                        </div>

                        {/* MÃ³dulos */}
                        <div className="form-group modulos-section">
                            <label>ðŸ“¦ MÃ³dulos habilitados para este usuario</label>
                            <p className="modulos-hint" style={{marginTop: 2, marginBottom: 8}}>
                                Solo puedes asignar mÃ³dulos que la empresa tenga activos. Selecciona cuÃ¡les tendrÃ¡ este usuario.
                            </p>

                            {modLoading ? (
                                <div className="admin-loading-inline"><div className="admin-spinner-sm"></div> Cargando...</div>
                            ) : !form.empresa ? (
                                <p className="modulos-hint">âš ï¸ Selecciona una empresa para ver los mÃ³dulos disponibles.</p>
                            ) : modulosDeEmpresa.length === 0 ? (
                                <p className="modulos-hint">âš ï¸ Esta empresa no tiene mÃ³dulos activos. ActÃ­valos en la pestaÃ±a <strong>MÃ³dulos</strong>.</p>
                            ) : (
                                <>
                                    <div className="modulos-grid">
                                        {modulosDeEmpresa.map(mod => {
                                            const info = MODULO_INFO[mod.id] || {}
                                            const activo = form.modulosHabilitados.includes(mod.id)
                                            return (
                                                <label
                                                    key={mod.id}
                                                    className={`modulo-toggle-card ${activo ? 'modulo-toggle-card--on' : ''}`}
                                                    onClick={() => toggleModulo(mod.id)}
                                                >
                                                    <div className="modulo-toggle-icon">{info.icono || mod.icono || 'ðŸ”§'}</div>
                                                    <div className="modulo-toggle-name">{info.nombre || mod.nombre || mod.id}</div>
                                                    <div className={`modulo-toggle-switch ${activo ? 'switch-on' : 'switch-off'}`}>
                                                        {activo ? 'âœ“' : 'âˆ’'}
                                                    </div>
                                                </label>
                                            )
                                        })}
                                    </div>
                                    <div className="modulos-actions-row">
                                        <button type="button" className="btn-ghost btn-sm"
                                            onClick={() => setForm(f => ({ ...f, modulosHabilitados: modulosDeEmpresa.map(m => m.id) }))}>
                                            Seleccionar todos
                                        </button>
                                        <button type="button" className="btn-ghost btn-sm"
                                            onClick={() => setForm(f => ({ ...f, modulosHabilitados: [] }))}>
                                            Quitar todos
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>

                        <div className="form-actions">
                            <button type="button" className="btn-ghost" onClick={() => setEditUser(null)}>Cancelar</button>
                            <button type="submit" className="btn-primary" disabled={saving}>
                                {saving ? 'Guardando...' : 'ðŸ’¾ Guardar permisos'}
                            </button>
                        </div>
                    </form>
                </div>
            )}

            {/* â”€â”€ Tabla â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
            {loading ? (
                <div className="admin-loading-inline"><div className="admin-spinner-sm"></div> Cargando usuarios...</div>
            ) : (
                <div className="admin-table-wrapper">
                    <table className="admin-table">
                        <thead>
                            <tr>
                                <th>Usuario</th>
                                <th>Email</th>
                                <th>Empresa</th>
                                <th>Estado</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.map(u => (
                                <tr key={u.username}>
                                    <td>
                                        <div className="user-cell">
                                            <div className="user-avatar-sm">{(u.name || u.email).charAt(0).toUpperCase()}</div>
                                            <span>{u.name || 'â€”'}</span>
                                        </div>
                                    </td>
                                    <td><code className="code-badge">{u.email}</code></td>
                                    <td>
                                        {u.empresa
                                            ? <span className="company-badge">{u.empresa}</span>
                                            : <span className="no-value">Sin empresa</span>
                                        }
                                    </td>
                                    <td>
                                        <span className={`status-badge ${u.enabled ? 'status-active' : 'status-inactive'}`}>
                                            {u.enabled ? 'â— Activo' : 'â—‹ Inactivo'}
                                        </span>
                                    </td>
                                    <td className="actions-cell">
                                        <button className="btn-sm btn-primary"
                                            onClick={() => setFormModal(u)} title="Editar nombre">
                                            âœï¸
                                        </button>
                                        <button className="btn-sm btn-primary"
                                            onClick={() => handleConfigPermisos(u)} title="Configurar empresa y mÃ³dulos">
                                            âš™ï¸
                                        </button>
                                        <button
                                            className={`btn-sm ${u.enabled ? 'btn-danger' : 'btn-ghost'}`}
                                            onClick={() => handleToggleEnabled(u)}
                                            disabled={toggling === u.username}
                                            title={u.enabled ? 'Desactivar usuario' : 'Activar usuario'}
                                        >
                                            {toggling === u.username ? '...' : (u.enabled ? 'ðŸš«' : 'âœ…')}
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {filtered.length === 0 && (
                        <div className="admin-empty">
                            <span>ðŸ”</span>
                            <p>No hay usuarios que coincidan con la bÃºsqueda.</p>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

export default UsuariosManager
